<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!-- title -->
        <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
          <h4 style="padding-left: 6px"> {{ i18nValues["producerAdmin"] }} </h4>
          <el-button 
            v-if="componentsMap.get('producer_create')" 
            icon="fas fa-plus" 
            size="small" 
            class="btn-primary" 
            @click="add()"
          > 
            {{ i18nValues["add"] }} 
          </el-button>
        </div>  
      
        <!-- form -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0">
            <div class="filters-wrapper">
              <div class="filters-row">
  
                <!-- search by Name -->
                <el-form-item :label="i18nValues['name']" prop="name">
                  <el-input v-model="filter.name" :placeholder="i18nValues['name']"></el-input>
                </el-form-item> 

                <!-- search by Last Name -->
                <el-form-item :label="i18nValues['lastName']" prop="lastName">
                  <el-input v-model="filter.lastName" :placeholder="i18nValues['lastName']"></el-input>
                </el-form-item> 

                <!-- search by Business Name -->
                <el-form-item :label="i18nValues['businessName']" prop="businessName">
                  <el-input v-model="filter.businessName" :placeholder="i18nValues['businessName']"></el-input>
                </el-form-item> 
                
                <!-- search button  -->
                <el-button
                  @click="retrieveProducersBySearch()"
                  icon="fas fa-search"
                  id="searchButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["search"] }}
                </el-button>
              </div>
            </div>
  
            <!-- table -->
            <el-form-item prop="producers">
              <div class="full-width" style="margin:0 auto;padding:20px;">
                  <el-table
                    :key="tableSortKey"
                    :data="ProducersSubList"
                    id="ProducersTable"
                    class="table table-hover"
                    align="center"
                    :empty-text="i18nValues['noDataAvailable']"
                    :default-sort="tableDefaultSort"
                    stripe
                    @sort-change="handleSortChange"
                  >
  
                    <!-- Producer Name -->
                    <el-table-column
                      prop="name" 
                      :label= "i18nValues['name']"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- Producer Last Name -->
                    <el-table-column
                      prop="lastName" 
                      :label= "i18nValues['lastName']"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>
  
                    <!-- Producer Number-->
                    <el-table-column
                      prop="number" 
                      :label= "i18nValues['number']"
                      width="75"
                      align="right"
                      sortable
                    ></el-table-column>

                    <!-- Producer Business Name-->
                    <el-table-column
                      prop="businessName" 
                      :label= "i18nValues['businessName']"
                      width="75"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- EDIT/DELETE -->
                    <el-table-column width="90" align="right">
                      <template slot-scope="scope">
                        <el-button 
                          v-if="componentsMap.get('producer_modification')" 
                          class="text-info"
                          icon="fas fa-edit"
                          size="small"
                          :title="i18nValues['edit']"
                          @click="edit(scope.row.id)"
                        ></el-button>
  
                        <el-button 
                          v-if="componentsMap.get('producer_delete')"
                          class="text-danger"
                          icon="fas fa-times"
                          size="small"
                          :title="i18nValues['remove']"
                          @click="deleteProducer(scope.row.id)"
                        ></el-button>
                      </template>
                     </el-table-column>                  
                </el-table>
                <div v-if="90 > 10" style="height: 15px"></div>
                  <div class="pagination-bar">
                    <PaginationFunctional
                      ref="pagination"
                      sublistName="ProducersSubList"
                      :fullList="ProducersList"
                      :tableSize="20"
                      :tableIndexInitial="initialPage"
                      @paginationChange="paginationChange"
                      @currentIndexPagination="setCurrentPage"
                      class="text-center"
                    /> 
                    <div v-if="ProducersList.length > 0" class="results-info">
                      <p>
                        {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                      </p>
                    </div>
                  </div>
              </div>
            </el-form-item>      
  
          </el-form>

        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  import PaginationFunctional from "@/components/PaginationFunctional.vue"
  export default {
    name: "ProducerAdmin",
    created() {
      this.restoreFromQuery();
      this.runInitialSearchIfFiltersPresent();
      this.retrieveProducerCount();
    },
  
    components: {
      PaginationFunctional 
    },
  
    computed: {
      loading: get("producer/loading"),

      // Pagination helpers for results label
      currentPage() {
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        return this.initialPage || 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
        if (Array.isArray(this.ProducersList)) {
          return this.ProducersList.length;
        }
        return typeof this.cantidad === "number" ? this.cantidad : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },

      tableDefaultSort() {
        if (this.sortProp && this.sortOrder) {
          return { prop: this.sortProp, order: this.sortOrder };
        }
        return {};
      },

      tableSortKey() {
        // Key changes when sort changes, forcing table to re-render with new default-sort
        return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
      },
    },
  
    props:{
      componentsMap: {},
    },
  
    data() {
      return {
        filter: {},
  
        ProducersList: [],
        ProducersSubList: [],
      cantidad: 100,
      initialPage: 1,
      sortProp: null,
      sortOrder: null,
      isUpdatingRoute: false,
  
      };
    },
  
    methods: {
      retrieveProducers({ preservePage = false, targetPage = null } = {}) {
        this.$store.dispatch("producer/retrieveProducers").then((res) => {
          let processedList = res;
          // Apply sorting if sort parameters are present (before setting ProducersList)
          if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
            const sorted = this.$refs.pagination.handleSortChangePagination({
              prop: this.sortProp,
              order: this.sortOrder
            }, processedList);
            if (Array.isArray(sorted)) {
              processedList = sorted;
            }
          }
          // Set the processed list
          this.ProducersList = processedList;
          
          // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
          const resolvedTarget = typeof targetPage === "number" && targetPage > 0
            ? targetPage
            : this.initialPage || 1;
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(resolvedTarget);
              }
            });
          });
          // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
          if (!preservePage) {
            this.updateRouteQuery();
          }
          // When preservePage is true, the URL already has the correct state, so we don't update it
        });
      },
  
      retrieveProducersBySearch(preservePage = false) {
        console.log(this.filter);//eslint-disable-line
        if(this.filter.name == ""){
          this.filter.name = null;
        }
        if(this.filter.lastName == ""){
          this.filter.lastName = null;
        }
        if(this.filter.businessName == ""){
          this.filter.businessName = null;
        }

        if (
          this.filter.name == null &&
          this.filter.lastName == null &&
          this.filter.businessName == null
        ) {
          this.retrieveProducers({ preservePage });
        } else {
          this.$store.dispatch("producer/retrieveProducersBySearch" , this.filter).then((res) => {
            let processedList = res;
            
            // Apply sorting if sort parameters are present
            if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
              const sorted = this.$refs.pagination.handleSortChangePagination({
                prop: this.sortProp,
                order: this.sortOrder
              }, processedList);
              if (Array.isArray(sorted)) {
                processedList = sorted;
              }
            }
            
            this.ProducersList = processedList;
            
            const targetPage = preservePage ? this.initialPage || 1 : 1;
            if (!preservePage) {
              this.initialPage = 1;
            }
            
            // Sync pagination after loading
            this.$nextTick(() => {
              this.$nextTick(() => {
                if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                  this.$refs.pagination.currentChange(targetPage);
                }
              });
            });
            
            // Update URL after search
            if (preservePage) {
              this.updateRouteQuery();
            } else {
              this.updateRouteQuery({ page: 1 });
            }
          });
        }
      },
  
      add() {
        this.$router.push({
          name: `ProducerEdition`,
          params: { id: "0" },
        query: this.$route.query,
        });
      },
  
      edit(id) {
        this.$router.push({
          name: `ProducerEdition`,
          params: { id: id },
        query: this.$route.query,
        });
        //console.log(this.id);//eslint-disable-line
      },
  
      deleteProducer(id) {
        this.$confirm('Está seguro que quiere eliminar al productor?', 'Eliminar Productor', {
                distinguishCancelAndClose: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
              this.$store.dispatch("producer/deleteProducer" , id).then((res)=>{
                if (res.status == "OK") {
                  this.$notify.success({
                    title: this.i18nValues["success"],
                    message: this.i18nValues["producerDeleted"],
                    position: "bottom-right",
                  });
                  // After delete, reload using current filters/sort and keep pagination state
                  this.runInitialSearchIfFiltersPresent();
                  this.retrieveProducerCount();
                } else {
                  this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["producerDeletError"],
                    position: "bottom-right",
                  });
                }       
              });
            })
      },

      retrieveProducerCount() {
        this.$store
          .dispatch("producer/countProducers")
          .then((res) => {
            this.cantidad = res;
          });
      },
  
    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (sortChanged) {
        this.ProducersList = this.$refs.pagination.handleSortChangePagination(event);
        this.initialPage = 1;
        this.updateRouteQuery({
          sortProp: this.sortProp || undefined,
          sortOrder: this.sortOrder || undefined,
          page: 1,
        });
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(1);
          }
        });
      } else {
        this.ProducersList = this.$refs.pagination.handleSortChangePagination(event);
      }
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.ProducersSubList = evt.list;
      }
      const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
      this.updateRouteQuery({ page: currentIdx });
    },

    setCurrentPage(idx) {
      if (typeof idx === 'number') {
        this.updateRouteQuery({ page: idx });
      }
    },

    hasFiltersInQuery() {
      const q = this.$route.query || {};
      return !!(
        q.name ||
        q.lastName ||
        q.businessName ||
        // Also check component state in case query hasn't updated yet
        (this.filter && this.filter.name) ||
        (this.filter && this.filter.lastName) ||
        (this.filter && this.filter.businessName)
      );
    },

    runInitialSearchIfFiltersPresent() {
      if (this.hasFiltersInQuery()) {
        this.retrieveProducersBySearch(true); // preservePage = true when loading from URL
      } else {
        // Even without filters, we need to load producers and preserve page/sort from URL
        this.retrieveProducers({ 
          preservePage: true, 
          targetPage: this.initialPage || 1 
        });
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter = this.filter || {};
      if (q.name) this.filter.name = q.name;
      if (q.lastName) this.filter.lastName = q.lastName;
      if (q.businessName) this.filter.businessName = q.businessName;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    updateRouteQuery(partial) {
      const base = this.buildQueryFromState();
      const next = Object.assign({}, base, partial || {});
      const cleaned = {};
      Object.keys(next).forEach(k => {
        const v = next[k];
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      this.isUpdatingRoute = true;
      const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
      this.$router.replace({ query: cleaned }).then(done).catch(done);
    },

    buildQueryFromState() {
      const q = {};
      if (this.filter && this.filter.name) q.name = this.filter.name;
      if (this.filter && this.filter.lastName) q.lastName = this.filter.lastName;
      if (this.filter && this.filter.businessName) q.businessName = this.filter.businessName;
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
      else if (this.initialPage) q.page = this.initialPage;
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      return q;
    },
  },
  watch: {
    $route() {
      this.restoreFromQuery();
      this.$nextTick(() => {
        // Check if filters are present in the URL and run search if needed
        if (this.hasFiltersInQuery()) {
          this.retrieveProducersBySearch(true); // preservePage = true when loading from URL
        } else {
          // Even without filters, reload producers to preserve page/sort from URL
          this.retrieveProducers({ 
            preservePage: true, 
            targetPage: this.initialPage || 1 
          });
        }
      });
    }
  }
};
  
  </script>

<style scoped>
.filters-wrapper {
  margin-bottom: 20px;
}

.filters-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row .el-input,
.filters-row .el-select {
  width: 180px;
}

.filters-row .el-input >>> .el-input__inner,
.filters-row .el-select >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-date-editor {
  width: 180px;
}

.filters-row .el-date-editor >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>